import { useContext, useEffect, useState } from 'react'
import AuthContext from 'contexte/AuthContext'
import Modal from 'components/modal/Modal'
import PageLoader from 'components/pageLoader/PageLoader'
import { launchError, launchSuccess } from 'components/notifications'
import { fetchSpCouponsPreview, loadSpCoupons } from 'services/structuredProductsServices'
import { couponsErrorLabel } from './couponsErrors'
import CouponsTable from './CouponsTable'

// Lit le term sheet déjà enregistré sur le produit, montre les coupons, puis les crée
const LoadCouponsModal = ({ productId, isOpen, onClose, onLoaded }) => {
  const { user } = useContext(AuthContext)
  const [preview, setPreview] = useState(null)
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    setPreview(null)
    setLoading(true)
    fetchSpCouponsPreview({ user, productId })
      .then(setPreview)
      .catch(() => { launchError('Erreur lors de la lecture du term sheet'); onClose() })
      .finally(() => setLoading(false))
  }, [isOpen])

  const confirm = async () => {
    try {
      setSaving(true)
      const { coupons_created } = await loadSpCoupons({ user, productId })
      launchSuccess(`${coupons_created} coupons créés`)
      onLoaded?.()
      onClose()
    } catch (error) {
      launchError(couponsErrorLabel(error?.response?.data?.error) || 'Erreur lors de la création des coupons')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={'700px'}>
      <h2>Charger les coupons</h2>
      {loading || !preview ? (
        <div className='pageLoaderBox'><PageLoader /></div>
      ) : (
        <div className='close_sp_modal'>
          <p>{preview.name} — total <b>{preview.total} €</b></p>
          {preview.term_sheet_url && <p><a href={preview.term_sheet_url} target='_blank' rel='noreferrer'>Voir le term sheet</a></p>}
          {preview.coupons?.length > 0 ? (
            <>
              <p>{preview.coupons.length} coupons seront créés, et la date du prochain paiement mise à jour :</p>
              <CouponsTable coupons={preview.coupons} />
            </>
          ) : (
            <p className='close_sp_modal_warning'>{couponsErrorLabel(preview.coupons_error)}</p>
          )}
          <div className='close_sp_modal_actions'>
            <button className='b_book_secondary_button' onClick={onClose}>Annuler</button>
            {preview.coupons?.length > 0 && (
              <button className='b_book_action_button' disabled={saving} onClick={confirm}>{saving ? 'Création...' : 'Créer les coupons'}</button>
            )}
          </div>
        </div>
      )}
    </Modal>
  )
}

export default LoadCouponsModal
